import SelectField from '@pelckmans/elementis/components/select-field';
import { ComponentProps } from 'react';

type Module = {
  id: string;
  niceName: string;
  catalogName?: string;
  isVirtualExerciseModule?: boolean;
};

type UnwrapArray<T> = T extends (infer U)[] ? U : T;

type Props<T> = {
  modules: T[];
  selectedModule: UnwrapArray<T> | null;
  setSelectedModule: (module: T) => void;
  ariaLabel: string;
  dropdownMenuAriaLabel?: string;
  useCatalogName?: boolean;
  className?: string;
  size?: ComponentProps<typeof SelectField>['size'];
};

export default function ModuleSelectionField<T extends Module>({
  modules,
  selectedModule,
  setSelectedModule,
  ariaLabel,
  dropdownMenuAriaLabel,
  useCatalogName,
  className,
  size = 'sm',
}: Props<T>) {
  return modules.length > 0 ? (
    <SelectField
      value={selectedModule}
      onChange={setSelectedModule}
      renderValueContent={module => (useCatalogName ? module.catalogName || module.niceName : module.niceName)}
      required
      size={size}
      aria-label={ariaLabel}
      dropdownMenuProps={{
        ariaLabel: dropdownMenuAriaLabel,
      }}
      className={className}
      disabled={modules.length === 1}
    >
      {modules.map(module => (
        <SelectField.Item
          value={module}
          text={useCatalogName ? module.catalogName || module.niceName : module.niceName}
          key={`${module.id}-${module.isVirtualExerciseModule}`}
        />
      ))}
    </SelectField>
  ) : null;
}
